var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-card",
        { staticClass: "px-6 py-6" },
        [
          !_vm.loadingProject
            ? _c(
                "div",
                [
                  _c("h1", [_vm._v(_vm._s(_vm.project.name))]),
                  _c("v-spacer"),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `https://${_vm.project.domain}`,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.project.domain) + " "),
                      _c(
                        "v-icon",
                        { staticClass: "ml-1", attrs: { small: "" } },
                        [_vm._v(" mdi-open-in-new ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.loadingProject
            ? _c(
                "div",
                { staticClass: "my-5 d-flex justify-center" },
                [
                  _c("v-progress-circular", {
                    staticClass: "px-8",
                    attrs: { indeterminate: "" },
                  }),
                  _c("span", [_vm._v(" Loading project.. ")]),
                ],
                1
              )
            : _vm._e(),
          _c("transition", { attrs: { name: "stf-fade" } }, [
            !_vm.loadingProject
              ? _c(
                  "div",
                  { staticClass: "project-info" },
                  [
                    _c(
                      "div",
                      { staticClass: "mt-2 mb-4" },
                      [
                        _vm.project.status
                          ? _c(
                              "v-chip",
                              {
                                class: {
                                  flat: !_vm.isFailStatus,
                                  red: _vm.isFailStatus,
                                  green: _vm.isSuccessStatus,
                                },
                                attrs: { label: "", small: "" },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "status-chip mt-4 display-block",
                                  },
                                  [
                                    _vm.isFailStatus || _vm.isInitializingStatus
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { right: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              class: {
                                                                "text-white":
                                                                  _vm.isFailStatus,
                                                              },
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                            },
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.project
                                                                  .status
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1337245178
                                            ),
                                          },
                                          [
                                            _vm.isFailStatus
                                              ? _c("span", [
                                                  _vm._v(" An error occured:"),
                                                  _c("br"),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.project
                                                          .error_message
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm.isInitializingStatus
                                              ? _c("span", [
                                                  _vm._v(
                                                    " We're fetching your keywords, hang tight! "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            class: {
                                              "text-white": _vm.isFailStatus,
                                            },
                                            staticStyle: { cursor: "pointer" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.project.status) +
                                                " "
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.isFailStatus
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "mx-2",
                                attrs: {
                                  title: "Retry Project",
                                  "x-small": "",
                                },
                                on: { click: _vm.retryProject },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v(" mdi-refresh "),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c("p", [
                            _c("b", [_vm._v("Description")]),
                            _c("br"),
                            _vm._v(" " + _vm._s(_vm.project.description) + " "),
                          ]),
                        ]),
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c("p", [
                            _c("b", [_vm._v("Target audience:")]),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.project.target_audience ||
                                    "No target audience set"
                                ) +
                                " - " +
                                _vm._s(
                                  _vm.project.target_audience_geographical_area
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "3" } }, [
                          _vm.project.seeds && _vm.project.seeds.length > 0
                            ? _c(
                                "p",
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-black ml-2" },
                                    [_vm._v("Seeds:")]
                                  ),
                                  _c("br"),
                                  _vm._l(_vm.project.seeds, function (seed) {
                                    return _c(
                                      "v-chip",
                                      {
                                        key: seed,
                                        staticClass: "ma-1",
                                        attrs: {
                                          color: "primary",
                                          outlined: "",
                                          "x-small": "",
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(seed) + " ")]
                                    )
                                  }),
                                ],
                                2
                              )
                            : _c("p", [_vm._v("No seeds set")]),
                        ]),
                      ],
                      1
                    ),
                    !_vm.rows
                      ? _c("div", [_vm._v("No project data available.")])
                      : _vm._e(),
                    _c("p", { staticClass: "text-sm" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.back()
                            },
                          },
                        },
                        [_vm._v(" Back to Previous Page ")]
                      ),
                    ]),
                    _c("v-divider", { staticClass: "my-4" }),
                    _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c(
                            "div",
                            { staticClass: "mb-1" },
                            [
                              _c("b", [_vm._v("Major Groups")]),
                              _vm.active_major_group
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-clear-group ma-1 ml-3",
                                      attrs: {
                                        outlined: "",
                                        rounded: "",
                                        small: "",
                                      },
                                      on: { click: _vm.clearMajorGroup },
                                    },
                                    [_vm._v(" Clear Major Group ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.project.project_data &&
                          Object.keys(_vm.project.project_data).length > 0
                            ? _c(
                                "div",
                                { staticClass: "d-flex flex-wrap gap-2" },
                                _vm._l(
                                  Object.keys(_vm.project.project_data),
                                  function (major_group) {
                                    return _c(
                                      "v-btn",
                                      {
                                        key: major_group,
                                        staticClass: "ma-1 flex-column",
                                        class: {
                                          "active-cluster":
                                            _vm.active_major_group ===
                                            major_group,
                                        },
                                        attrs: {
                                          color: "primary",
                                          outlined: "",
                                          rounded: "",
                                          small: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.rows = _vm.prepareMajorGroup(
                                              _vm.project.project_data[
                                                major_group
                                              ],
                                              major_group,
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(major_group) + " ( "
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "align-center" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-xxs" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.groupSizes.find(
                                                        (g) =>
                                                          g.group ===
                                                          major_group
                                                      ).size
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" ) "),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ]),
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c(
                            "div",
                            { staticClass: "mb-1" },
                            [
                              _c("b", [_vm._v("Minor Groups")]),
                              _vm.active_minor_group
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-clear-group ma-1",
                                      attrs: {
                                        color:
                                          "\n                  grey lighten-1\n                ",
                                        outlined: "",
                                        rounded: "",
                                        small: "",
                                      },
                                      on: { click: _vm.clearMinorGroup },
                                    },
                                    [_vm._v(" Clear Minor Group ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.active_major_group &&
                          Object.keys(
                            _vm.project.project_data[_vm.active_major_group]
                          ).length > 0
                            ? _c(
                                "div",
                                { staticClass: "d-flex flex-wrap gap-2" },
                                _vm._l(
                                  Object.keys(
                                    _vm.project.project_data[
                                      _vm.active_major_group
                                    ]
                                  ),
                                  function (minor_group) {
                                    return _c(
                                      "v-btn",
                                      {
                                        key: minor_group,
                                        staticClass: "ma-1",
                                        class: {
                                          "active-cluster":
                                            _vm.active_minor_group ===
                                            minor_group,
                                        },
                                        attrs: {
                                          color: "secondary",
                                          outlined: "",
                                          rounded: "",
                                          small: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.rows = _vm.prepareMinorGroup(
                                              _vm.project.project_data[
                                                _vm.active_major_group
                                              ][minor_group],
                                              minor_group
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(minor_group) + " ( "
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "align-center" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-xxs text-bold",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.project.project_data[
                                                        _vm.active_major_group
                                                      ][minor_group].length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" ) "),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                    _vm.rows
                      ? _c("v-data-table", {
                          staticClass: "elevation-1 compact-table mt-4",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.filteredRows,
                            search: _vm.search,
                            "items-per-page": 25,
                            "footer-props": {
                              "items-per-page-options": [10, 25, 100, -1],
                              "items-per-page-text": "Keywords per page",
                              "show-first-last-page": true,
                            },
                            loading: _vm.loadingProject,
                            "loading-text": "Loading... Please wait",
                            "multi-sort": "",
                            "sort-by": ["avg_monthly_searches", "competition"],
                            "sort-desc": [true, false],
                            dense: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "top",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-row",
                                      { staticClass: "mx-4" },
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "3" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Max Competition",
                                                type: "number",
                                                min: "0",
                                                max: "100",
                                                step: "1",
                                                dense: "",
                                                outlined: "",
                                                clearable: "",
                                              },
                                              model: {
                                                value: _vm.competitionFilter,
                                                callback: function ($$v) {
                                                  _vm.competitionFilter =
                                                    _vm._n($$v)
                                                },
                                                expression: "competitionFilter",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "7" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Search",
                                                dense: "",
                                                outlined: "",
                                              },
                                              model: {
                                                value: _vm.search,
                                                callback: function ($$v) {
                                                  _vm.search = $$v
                                                },
                                                expression: "search",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "d-flex justify-end",
                                            attrs: { cols: "2" },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { small: "" },
                                                on: { click: _vm.downloadCSV },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { left: "" } },
                                                  [_vm._v("mdi-download")]
                                                ),
                                                _c("span", [
                                                  _vm._v("Download CSV"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "item.score",
                                fn: function ({ item }) {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(item.score.toFixed(2)) + " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "footer",
                                fn: function () {
                                  return [
                                    _vm.filteredCount > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-end pa-2",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "grey--text text--darken-1 text-xs",
                                              },
                                              [
                                                _vm._v(
                                                  " (" +
                                                    _vm._s(_vm.filteredCount) +
                                                    " keyword" +
                                                    _vm._s(
                                                      _vm.filteredCount === 1
                                                        ? ""
                                                        : "s"
                                                    ) +
                                                    " hidden by filter) "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1506835735
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }